// extracted by mini-css-extract-plugin
export default {"mobileBreakpoint":"767px","footer":"block_footer__-7gJ-","item":"block_item__C0V48"};